import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function UsageInspectorDayDrawer({
    open,
    data,
    onClose,
    resolveActivity
}) {

    const safeData = data || {};

    // ----------------------------------------------------
    // BOOKING STATUS
    // ----------------------------------------------------

    function getBookingStatus(h) {

		if (h.bookingStatus === 1) {
		    return {
		        label: "Booked",
		        color: "#f59e0b"
		    };
		}

		if (h.bookingStatus === 2) {
		    return {
		        label: "No Show",
		        color: "#ef4444"
		    };
		}

		if (h.bookingStatus === 3) {
		    return {
		        label: "Ghost",
		        color: "#8b5cf6"
		    };
		}

        return null;

    }

    // ----------------------------------------------------
    // DEDUPE
    // ----------------------------------------------------

    function getHours() {

        if (!safeData.hours) {

            return [];

        }

        return safeData.hours.filter(function (
            h,
            index,
            arr
        ) {

            var key =
                h.hour + "_" +
                (h.activityId || 0) + "_" +
                (h.bookingStatus || 0);

            return index === arr.findIndex(function (x) {

                var compareKey =
                    x.hour + "_" +
                    (x.activityId || 0) + "_" +
                    (x.bookingStatus || 0);

                return compareKey === key;

            });

        });

    }

    // ----------------------------------------------------
    // RENDER
    // ----------------------------------------------------

    return (

        <div
            style={{

                position: "fixed",
                top: "60px",
                right: 0,
                bottom: 0,
                width: "760px",

                background:
                    "linear-gradient(180deg, #0f172a 0%, #081225 100%)",

                color: "#e5e7eb",

                boxShadow:
                    "-12px 0 40px rgba(0,0,0,0.6)",

                zIndex: 3000,

                display: "flex",
                flexDirection: "column",

                transform: open
                    ? "translateX(0px)"
                    : "translateX(100%)",

                opacity: open ? 1 : 0,

                transition:
                    "transform 0.45s cubic-bezier(.22,.61,.36,1)," +
                    "opacity 0.25s ease"

            }}
        >

            {/* HEADER */}

			{/* HEADER */}
			<div
			    style={{

			        padding: "12px 20px",

			        borderBottom:
			            "1px solid rgba(255,255,255,0.08)",

			        display: "flex",

			        justifyContent: "space-between",

			        alignItems: "center",

			        background:
			            "rgba(15,23,42,0.98)",

			        minHeight: "58px",

			        flexShrink: 0,

			        position: "relative",

			        zIndex: 20

			    }}
			>

                {/* TITLE */}

                <div>

				<div
				    style={{
				        fontSize: "18px",
				        fontWeight: "700",
				        letterSpacing: "0.2px",
				        lineHeight: "20px"
				    }}
				>
				    {safeData.spaceCode}
				</div>

				<div
				    style={{
				        fontSize: "11px",
				        color: "#94a3b8",
				        marginTop: "2px"
				    }}
				>
				    {safeData.date}
				</div>

                </div>

                {/* FLOATING CLOSE BUTTON */}

                <div
                    onClick={onClose}
                    style={{

                        position: "absolute",

                        left: "-22px",

                        top: "calc(50vh - 70px)",

                        width: "44px",
                        height: "44px",

                        borderRadius: "50%",

                        background:
                            "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",

                        border:
                            "1px solid rgba(255,255,255,0.12)",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        color: "#fff",

                        cursor: "pointer",

                        boxShadow:
                            "0 10px 28px rgba(0,0,0,0.45)",

                        transition:
                            "all 0.2s ease",

                        zIndex: 999999

                    }}

                    onMouseEnter={function (e) {

                        e.currentTarget.style.transform =
                            "scale(1.08)";

                        e.currentTarget.style.background =
                            "#334155";

                    }}

                    onMouseLeave={function (e) {

                        e.currentTarget.style.transform =
                            "scale(1)";

                        e.currentTarget.style.background =
                            "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)";

                    }}
                >

                    <FontAwesomeIcon
                        icon={faXmark}
                        style={{
                            fontSize: "16px",
                            color: "#ffffff"
                        }}
                    />

                </div>

            </div>

            {/* BODY */}

            <div
                style={{

                    flex: 1,

                    overflowY: "hidden",

                    padding: "18px"

                }}
            >

                <div
                    style={{

                        display: "grid",

                        gridTemplateColumns:
                            "repeat(2, minmax(0, 1fr))",

                        gap: "14px"

                    }}
                >

                    {getHours().map(function (h) {

                        var resolved =
                            resolveActivity(h);

                        var booking =
                            getBookingStatus(h);

                        var used =
                            h.capacityUsed || 0;

                        var cap =
                            safeData.capacity ||
                            h.capacity ||
                            0;

                        var pct =
                            cap > 0
                                ? Math.round(
                                    (used / cap) * 100
                                )
                                : 0;

                        return (

                            <div
                                key={
                                    h.hour + "_" +
                                    (h.activityId || 0) + "_" +
                                    (h.bookingStatus || 0)
                                }

                                style={{

                                    background:
                                        "rgba(255,255,255,0.03)",

                                    border:
                                        "1px solid rgba(255,255,255,0.08)",

                                    borderRadius: "14px",

                                    minHeight: "100px",

                                    display: "grid",

                                    gridTemplateColumns:
                                        "130px 1fr",

                                    overflow: "hidden",

                                    boxShadow:
                                        "0 6px 18px rgba(0,0,0,0.25)"

                                }}
                            >

                                {/* LEFT */}

                                <div
                                    style={{

                                        padding: "14px",

                                        borderRight:
                                            "1px solid rgba(255,255,255,0.08)",

                                        display: "flex",

                                        flexDirection: "column",

                                        justifyContent: "space-between"

                                    }}
                                >

                                    <div>

                                        <div
                                            style={{

                                                fontSize: "16px",

                                                //fontWeight: "700",

                                                marginBottom: "14px",
												color: "#94a3b8"

                                            }}
                                        >

                                            {String(h.hour)
                                                .padStart(2, "0")}

                                            :00

                                        </div>

                                        <div
                                            style={{

                                                display: "flex",

                                                alignItems: "center",

                                                gap: "8px",

                                                marginBottom: "10px"

                                            }}
                                        >

                                            <div
                                                style={{

                                                    width: "10px",

                                                    height: "10px",

                                                    borderRadius: "50%",

                                                    background:
                                                        resolved.background

                                                }}
                                            />

                                            <div
                                                style={{
                                                    fontSize: "13px"
                                                }}
                                            >
                                                {resolved.label}
                                            </div>

                                        </div>

                                    </div>

                                    <div
                                        style={{

                                            fontSize: "12px",

                                            color: "#94a3b8"

                                        }}
                                    >

                                        {used}/{cap} • {pct}%

                                    </div>

                                </div>

                                {/* RIGHT */}

                                <div
                                    style={{

                                        padding: "14px",

                                        display: "flex",

                                        flexDirection: "column",

                                        justifyContent: "space-between"

                                    }}
                                >

                                    <div>

                                        {booking && (

                                            <div
                                                style={{

                                                    display: "inline-block",

                                                    background:
                                                        booking.color,

                                                    color: "#fff",

                                                    borderRadius:
                                                        "999px",

                                                    padding:
                                                        "4px 10px",

                                                    fontSize: "10px",

                                                    marginBottom: "14px",
													width:'100px'

                                                }}
                                            >

                                                {booking.label}

                                            </div>

                                        )}

                                        {h.bookingTitle && (

                                            <div>

                                                <div
                                                    style={{

                                                        fontSize: "13px",

                                                        fontWeight: "600",

                                                        marginBottom: "6px",

                                                        lineHeight: "18px"

                                                    }}
                                                >

                                                    {h.bookingTitle}

                                                </div>

                                                {h.bookedBy && (

                                                    <div
                                                        style={{

                                                            fontSize: "12px",

                                                            color: "#94a3b8"

                                                        }}
                                                    >

                                                        {h.bookedBy}

                                                    </div>

                                                )}

                                            </div>

                                        )}

                                    </div>

                                </div>

                            </div>

                        );

                    })}

                </div>

            </div>

        </div>

    );

}